import React from 'react';
import { Flex } from '@components';
import { Form, Input, Button, InputNumber, Radio } from 'antd';
import SiderMenu from '@pages/Assembly/siderMenu';
import Breadcrumb from '@pages/Assembly/Breadcrumb';
import TitleTop from '@pages/Assembly/titleTop';
import { message } from "antd/lib/index";
import NHFetch from "../../../../utils/NHFetch";
import createHistory from 'history/createHashHistory';
import NextButton from '@pages/SelfHelp/common/nextIndex'
import { getLoginUser } from '@utils/NHCore';
import CommonTip from "../common";
import { mkbz } from "@pages/Assembly/siderMenu/menuObj";
import Hint from "@pages/SelfHelp/common/hint";
const history = createHistory();
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const basePath = '/sdcsjszyxy/zzbd/fzcmtx';

const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 }
};

@Form.create()
export default class ClothingSize extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mkbz: 'GD014_1', // 假设这是新页面的模块标志
            hjmc: '',
            editable: true,
            initPOvalue: {
                nd: '',
                xsid: '',
                sftstx: '', // 是否特殊体型
                sg: '',     // 身高
                tz: '',     // 体重
                xw: '',     // 胸围
                yw: '',     // 腰围
                tw: '',     // 臀围
                bz: '',     // 备注
            },
            nextUrl: '',
            search: '',
            operable: true,
            nonOperationalData: {},
        };
    }

    // 渲染前获取信息
    componentDidMount() {
        this.queryQztjAndYlhj();
        this.getFzpo();
    }

    // 查询前置条件和依赖环节
    queryQztjAndYlhj = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        if (!xsid) {
            this.setState({
                nonOperationalData: { nologin: true },
                operable: false,
            });
            return;
        }
        let zzbdhjid = this.getQueryString('pkid');
        NHFetch("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid })
            .then(res => {
                if (res && res.data) {
                    let kfsj = res.data['kfsj'];
                    let ylhj = res.data['ylhj'];
                    let qzhj = res.data['qzhj'];
                    let nohj = res.data['nohj'];
                    this.setState({ nonOperationalData: res.data });
                    if (kfsj && kfsj['YXSJ'] != '1') {
                        this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        this.setState({ operable: false });
                    }

                    if (nohj) {
                        this.setState({ operable: false });
                    }
                }
            });
    }

    getQueryString = (name) => {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    }

    setMenuList = (menuList) => {
        let nextCount = 0;
        let bz = this.state.mkbz;
        menuList.map((elem, index) => {
            if (elem.HJDM == bz) {
                let hjmc = elem.HJMC;
                this.setState({ hjmc: hjmc })
                nextCount = index + 1;
                return;
            }
        });
        let menu = menuList[nextCount];
        if (menu) {
            let hjdm = menu.HJDM;
            if (hjdm.indexOf('GD') == 0) {
                let gdUrl = mkbz[hjdm];
                this.setState({
                    nextUrl: gdUrl,
                    search: 'pkid=' + menu.PKID,
                })
            } else if (hjdm.indexOf('ZDY') == 0) {
                let zdyUrl = "/customLink";
                this.setState({
                    nextUrl: zdyUrl,
                    search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX,
                })
            } else if(hjdm.indexOf('DCWJ')==0){
                let wjUrl  = "/customizeExamination";
                this.setState({
                    nextUrl:wjUrl,
                    search:'pkid='+menu.PKID+'&mkbz='+hjdm,
                })
            }
        } else {
            this.setState({
                nextUrl: '',
                search: '',
            })
        }
    }

    getFzpo() {
        const xsid = getLoginUser().userId;
        NHFetch(basePath+"/getXsFzcmtx", "GET", { xsid })
            .then(res => {
                if (res) {
                    if (res.data) {
                        this.setState({ initPOvalue: res.data, editable: false })
                    }
                }
            });
    }

    // 保存和修改
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (err) {
                return;
            }

            const xsid = getLoginUser().userId;
            const zzbdhjid = this.getUrlParams("pkid");
            let params = { xsid: xsid, zzbdhjid: zzbdhjid, formData: values };
            // 请求保存或修改数据
            NHFetch(basePath + '/saveXsFzcmtx', 'POST', params)
                .then(res => {
                    if (res) {
                        if (res.data == '1') {
                            message.success('信息保存成功！');
                            this.reloadMenu();
                            this.getFzpo();
                        } else {
                            message.error('信息保存失败，请重试！');
                        }
                    }
                })

        });
    };

    getUrlParams = (param) => {
        return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    };

    // 重新加载菜单
    reloadMenu = () => {
        this.refs.siderMenu.reloadMenuList()
    }

    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { editable, initPOvalue } = this.state;
        
        // 获取是否特殊体型的值
        const sftstxValue = getFieldValue('sftstx') !== undefined ? getFieldValue('sftstx') : initPOvalue.sftstx;

        return (
            <div>{this.state.operable ?
                <Flex className="w1180 mt-20" align="start">
                    <SiderMenu
                        ref={"siderMenu"}
                        setMenuList={this.setMenuList}
                        title="自助报到"
                        mkbz={this.state.mkbz}
                        menuType='自助报到'
                    />
                    <Flex.Item className="page_con_r">
                        <Breadcrumb
                            noLine
                            list={[
                                { name: '首页', url: '/index' },
                                { name: '自助报到', url: '/register' },
                                { name: this.state.hjmc }
                            ]}
                        />
                        <div className="box">
                            <TitleTop title={this.state.hjmc} extra={false} />
                            <Form onSubmit={this.handleSubmit}>
                                <div className="p-sw">
                                    <Flex align="start" wrap="wrap">
                                        <div className="form_item">
                                            <FormItem
                                                {...formItemLayout}
                                                label="是否特殊体型"
                                            >
                                                {getFieldDecorator('sftstx', {
                                                    initialValue: initPOvalue.sftstx,
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: '请选择是否特殊体型'
                                                        }
                                                    ]
                                                })(
                                                    editable ?
                                                        <RadioGroup>
                                                            <Radio value="1">是</Radio>
                                                            <Radio value="0">否</Radio>
                                                        </RadioGroup>
                                                        : <span>{initPOvalue.sftstx === '1' ? '是' : '否'}</span>
                                                )}
                                            </FormItem>
                                        </div>

                                        <div className="form_item">
                                            <FormItem
                                                {...formItemLayout}
                                                label="身高"
                                            >
                                                {getFieldDecorator('sg', {
                                                    initialValue: initPOvalue.sg,
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: '请填写身高'
                                                        }
                                                    ]
                                                })(
                                                    editable ?
                                                        <InputNumber
                                                            placeholder="请填写身高"
                                                            min={0}
                                                            max={300}
                                                            disabled={!editable}
                                                        />
                                                        : <span>{initPOvalue.sg}</span>
                                                )}&nbsp;&nbsp;<span>CM</span>
                                            </FormItem>
                                        </div>

                                        <div className="form_item">
                                            <FormItem
                                                {...formItemLayout}
                                                label="体重"
                                            >
                                                {getFieldDecorator('tz', {
                                                    initialValue: initPOvalue.tz,
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: '请填写体重'
                                                        }
                                                    ]
                                                })(
                                                    editable ?
                                                        <InputNumber
                                                            placeholder="请填写体重"
                                                            min={0}
                                                            max={500}
                                                            disabled={!editable}
                                                        />
                                                        : <span>{initPOvalue.tz}</span>
                                                )}&nbsp;&nbsp;<span>KG</span>
                                            </FormItem>
                                        </div>

                                        {/* 当选择"是"特殊体型时显示额外字段 */}
                                        {sftstxValue === '1' && (
                                            <>
                                                <div className="form_item">
                                                    <FormItem
                                                        {...formItemLayout}
                                                        label="胸围"
                                                    >
                                                        {getFieldDecorator('xw', {
                                                            initialValue: initPOvalue.xw,
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: '请填写胸围'
                                                                }
                                                            ]
                                                        })(
                                                            editable ?
                                                                <InputNumber
                                                                    placeholder="请填写胸围"
                                                                    min={0}
                                                                    max={200}
                                                                    disabled={!editable}
                                                                />
                                                                : <span>{initPOvalue.xw}</span>
                                                        )}&nbsp;&nbsp;<span>CM</span>
                                                    </FormItem>
                                                </div>

                                                <div className="form_item">
                                                    <FormItem
                                                        {...formItemLayout}
                                                        label="腰围"
                                                    >
                                                        {getFieldDecorator('yw', {
                                                            initialValue: initPOvalue.yw,
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: '请填写腰围'
                                                                }
                                                            ]
                                                        })(
                                                            editable ?
                                                                <InputNumber
                                                                    placeholder="请填写腰围"
                                                                    min={0}
                                                                    max={200}
                                                                    disabled={!editable}
                                                                />
                                                                : <span>{initPOvalue.yw}</span>
                                                        )}&nbsp;&nbsp;<span>CM</span>
                                                    </FormItem>
                                                </div>

                                                <div className="form_item">
                                                    <FormItem
                                                        {...formItemLayout}
                                                        label="臀围"
                                                    >
                                                        {getFieldDecorator('tw', {
                                                            initialValue: initPOvalue.tw,
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: '请填写臀围'
                                                                }
                                                            ]
                                                        })(
                                                            editable ?
                                                                <InputNumber
                                                                    placeholder="请填写臀围"
                                                                    min={0}
                                                                    max={200}
                                                                    disabled={!editable}
                                                                />
                                                                : <span>{initPOvalue.tw}</span>
                                                        )}&nbsp;&nbsp;<span>CM</span>
                                                    </FormItem>
                                                </div>
                                            </>
                                        )}

                                        <div className="form_item">
                                            <FormItem
                                                {...formItemLayout}
                                                label="备注"
                                            >
                                                {getFieldDecorator('bz', { initialValue: initPOvalue.bz })(
                                                    editable ?
                                                        <Input placeholder="请填写备注" disabled={!editable} />
                                                        : <span>{initPOvalue.bz}</span>
                                                )}
                                            </FormItem>
                                        </div>
                                    </Flex>
                                    <Hint />
                                    <div className="text-center mt-50">
                                            {editable && (
                                                <Button type="primary" htmlType="submit">
                                                保存
                                                </Button>
                                            )}

                                            {!editable && (
                                                <Button type="primary" onClick={() => this.setState({ editable: true })}>
                                                修改
                                                </Button>
                                            )}
                                        <NextButton nextUrl={this.state.nextUrl} search={this.state.search} />
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </Flex.Item>
                </Flex>
                : <CommonTip hjmc={"服装尺码填写"} key={'GD014_1'} mkbz='GD014_1' nonOperationalData={this.state.nonOperationalData} />}
            </div>
        );
    }
}